import React from 'react'
import { fields } from './constants'
import { useMailgunEventContext } from './Context'
import { ListHeader } from './ListHeader'
import { MailgunEventListRow } from './MailgunEventListRow'
import map from 'lodash/map'
import { MailgunEventDataTool } from './MailgunEventDataTool'
import { DataTable } from '../../DataTable/DataTable'
import { useTableContext } from '../../DataTable/Context'

export const MailgunEventList = () => {
  const { mailgunEventListResult } = useMailgunEventContext()
  return (
    <>
      <MailgunEventDataTool />
      <DataTable
        components={{ tableBody: TableBody }}
        name="email-logs-list-v1"
        fields={fields}
        listResult={mailgunEventListResult}
        stats={'email logs'}
        height={{ topMargin: 200 }}
        head={ListHeader}
        row={MailgunEventListRow}
      />
    </>
  )
}

export const TableBody = () => {
  const { listResult, row: Row } = useTableContext()

  return (
    <tbody>
      {map(listResult?.list, (listItem, index) => {
        return <Row key={listItem._id} {...listItem} _index={index} />
      })}
    </tbody>
  )
}
